import { useEffect } from "react";

/**
 * A fixed amber bar across the top of every page when this is NOT the live production build, so a
 * local copy of live data can never be mistaken for the real site. Driven by the build-time
 * __APP_ENV__ flag (vite.config.ts): "production" on the live Render build (no banner), "development"
 * on a local build (banner shown). Also prefixes the page title with "[DEV] ".
 *
 * Rendered on every top-level surface (landing, app, platform console) via main.tsx, so it appears
 * before sign-in too.
 */
export function DevBanner() {
  const isDev = __APP_ENV__ !== "production";

  useEffect(() => {
    if (!isDev) return;
    document.body.classList.add("has-dev-banner");
    if (!document.title.startsWith("[DEV]")) document.title = `[DEV] ${document.title}`;
    return () => {
      document.body.classList.remove("has-dev-banner");
    };
  }, [isDev]);

  if (!isDev) return null;

  return (
    <div className="dev-banner" role="status">
      DEVELOPMENT: a local copy of live data. Changes here do not affect the live site.
    </div>
  );
}
